/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Authenticator } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";

import {
  Home,
  CreateOrg,
  CreateSubOrg,
  ViewMyOrg,
  EditOrg,
  UserOrgs,
  UserOrgsTreeView,
  Settings,
  Customers,
  Customer,
  CreateUserProfile,
  UserProfile,
  MaintenancePlans,
  EditMaintenancePlans,
  CreateWorkInstruction,
  EditWorkInstruction,
  WorkInstructionsList,
  Places,
  WorkEvents,
  Services,
  EditService,
  EditWorkEvent,
  CreateProcedure,
  EditProcedure,
  DetailReport,
  ViewClient,
  // UserRole
} from "../pages";

import { UserRole } from "../pages/UserRole";

import { SummaryReport } from "../pages/Reports/Workevent";
import { getUserOrgs, getUserProfileData } from "../services";
import { organizationSlice } from "../reducers/organizationReducer";
import { AssetList } from "./../pages/Assets/AssetList";
import { CreateAsset } from "./../pages/Assets/CreateAsset";
import EditAsset from "../pages/Assets/EditAsset";
import SummaryReportDownload from "../pages/WorkEvents/SummaryReportDownload";
import { WorkItemProfile } from "../pages/WorkEvents/WorkItemProfile";
// import Navigation from "../components/Header/Navigation";

export function Root(props) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  let currentOrg = useSelector(
    (state) => state.organization?.currentOrganization
  );

  useEffect(() => {
    async function intialization() {
      try {
        const orgs = await getUserOrgs();
        const profileData = await getUserProfileData();
        let defaultOrg = null;
        if (profileData?.data?.default_org) {
          defaultOrg = orgs.find(
            (org) => org.id === profileData?.data?.default_org
          );
        } else {
          if (orgs?.length && !profileData?.data?.default_org) {
            defaultOrg = orgs[0];
          }
        }
        const response = await Auth.currentUserInfo();
        const userAttributes = response?.attributes;
        const user = await Auth.currentAuthenticatedUser();
        window?.localStorage.setItem(
          "IS_PLATFORM_ADMIN",
          user?.attributes["custom:plat_admin"]
            ? user?.attributes["custom:plat_admin"]
            : ""
        );
        setEmail(userAttributes?.email);
        dispatch(organizationSlice.actions.setOrganizations(orgs));
        dispatch(organizationSlice.actions.setDefaultOrganization(defaultOrg));
        if (
          !currentOrg ||
          window?.localStorage.getItem("REDUX_CURRENT_ORGANIZATION") ===
            undefined
        ) {
          dispatch(
            organizationSlice.actions.setCurrentOrganization(defaultOrg)
          );
        }
      } catch (error) {
        console.log("Unable to fetch user email");
        setEmail("");
      }
    }
    intialization();
  }, []);
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/">
            {/* <Navigation index={-1} /> */}
            <Home {...props} />
          </Route>
          {/* <Route exact path="/create-org">
            <CreateOrg {...props} />
          </Route> */}

          <Route exact path="/toplevelorg">
            <CreateOrg {...props} />
          </Route>

          <Route exact path="/role">
            <UserRole {...props} />
          </Route>

          <Route exact path="/create-sub-org/:orgId">
            <CreateSubOrg {...props} />
          </Route>
          <Route exact path="/customers">
            {/* <Navigation index={2} /> */}
            <Customers {...props} />
          </Route>
          <Route exact path="/customers/:id/:orgId">
            <ViewClient {...props} />
          </Route>
          <Route exact path="/customers/:id/:orgId/edit">
            <Customer {...props} />
          </Route>
          <Route exact path="/my-org/:orgId">
            <ViewMyOrg {...props} />
          </Route>
          <Route exact path="/orgs/:id/edit">
            <EditOrg {...props} />
          </Route>
          <Route exact path="/orgs">
            <UserOrgs {...props} />
          </Route>
          <Route exact path="/orgs/tree-view/:id">
            <UserOrgsTreeView {...props} />
          </Route>
          <Route exact path="/maintenance-plans">
            <MaintenancePlans {...props} />
          </Route>
          <Route exact path="/services">
            <Services {...props} />
          </Route>
          <Route exact path="/services/:orgId/:id/edit">
            <EditService {...props} />
          </Route>
          <Route exact path="/maintenance-plans/:orgId/:id/edit">
            <EditMaintenancePlans {...props} />
          </Route>
          <Route
            exact
            path="/work-instructions/:orgId/:serviceTypeId/:serviceOptionId/create"
          >
            <CreateWorkInstruction {...props} />
          </Route>
          {/* Procedures */}
          <Route
            exact
            path="/procedures/:orgId/:serviceTypeId/:serviceOptionId/create"
          >
            <CreateProcedure {...props} />
          </Route>
          <Route
            exact
            path="/procedures/:orgId/:serviceTypeId/:serviceOptionId/:id/edit"
          >
            <EditProcedure {...props} />
          </Route>
          <Route exact path="/procedures">
            {/* <Navigation index={1} /> */}
            <WorkInstructionsList {...props} />
          </Route>
          {/*  */}
          {/* <Route exact path="/work-instructions">
            <WorkInstructionsList {...props}/>
          </Route> */}
          <Route
            exact
            path="/work-instructions/:orgId/:serviceTypeId/:serviceOptionId/:id/edit"
          >
            <EditWorkInstruction {...props} />
          </Route>

          <Route
            exact
            path="/reports/performing_org/:performing_org/workevent/:workEventId"
          >
            <SummaryReport />
          </Route>
          <Route
            exact
            path="/reports/workevent/:workEventId/workitem/:workItemId"
          >
            <DetailReport />
          </Route>
          <Route exact path="/places/:orgId/:customerId/">
            <Places {...props} />
          </Route>
          <Route exact path="/all-settings">
            <Settings {...props} />
          </Route>
          <Route exact path="/create-user-profile">
            <CreateUserProfile {...props} />
          </Route>
          <Route exact path="/work-events">
            {/* <Navigation index={3} /> */}
            <WorkEvents {...props} />
          </Route>
          <Route exact path="/work-events/:orgId/work-event/:id">
            <EditWorkEvent {...props} />
          </Route>
          <Route
            exact
            path="/work-events/:orgId/work-event/:workEventId/work-item/:workItemId"
          >
            <WorkItemProfile {...props} />
          </Route>
          <Route exact path="/work-events/:orgId/work-event/:id/download">
            <SummaryReportDownload />
          </Route>
          <Route
            exact
            path="/user-profile"
            render={() => <UserProfile email={email} {...props} />}
          />
          <Route exact path="/asset-list">
            <AssetList {...props} />
          </Route>
          <Route exact path="/create-asset">
            <CreateAsset {...props} />
          </Route>
          <Route exact path="/edit-asset/:orgId/:assetId">
            <EditAsset {...props} />
          </Route>
          <Authenticator
            displayLinks={false}
            product="Fluke Works"
            description={""}
            // description={
            //   "Description of application and benefits for the customer."
            // }
            Auth={Auth}
            onSignInRedirect="/"
          />
        </Switch>
      </Router>
    </>
  );
}
